export const config = {
    configuration: true,
    searchList: {
        searchTxt: [],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        selectBtn: true,
        leftOperation: false,
        height: 400,
        columns: [
            {
                label: '规则组代码',
                align: 'center',
                prop: 'ruleGroupCode',
                width: 120
            },
            {
                label: '规则组名称',
                align: 'center',
                prop: 'ruleGroupName',
                width: 120
            },
            {
                label: '状态',
                align: 'center',
                prop: 'recStatusName',
                width: 120
            },
            {
                label: '备注',
                align: 'center',
                prop: 'remark',
                width: 120
            },
            {
                label: '创建人',
                align: 'center',
                prop: 'createUserName',
                width: 120
            },
            {
                label: '创建时间',
                align: 'center',
                prop: 'createTime',
                width: 120
            },
            {
                label: '修改人',
                align: 'center',
                prop: 'updateUserName',
                width: 120
            },
            {
                label: '修改时间',
                align: 'center',
                prop: 'updateTime',
                width: 120
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
export const inFoList = [
    {
        label: '规则组代码',
        prop: 'ruleGroupCode',
        amendState: true
    },
    {
        label: '规则组名称',
        prop: 'ruleGroupName'
    },
    {
        label: '状态',
        prop: 'status',
        optionNum: 'REC_STATUS',
        options: [],
        type: 'select'
    },
    {
        label: '备注',
        prop: 'remark',
        type: 'textarea',
        span: 15
    }
];
export const inFoTable = [
    {
        label: '条码规则代码',
        prop: 'ruleCode',
        type: 'advance',
        mustFill: true,
        require: true,
        width: 120
    },
    {
        label: '条码规则名称',
        prop: 'ruleName'
    },
    {
        label: '条码位数',
        prop: 'codeNum'
    },
    {
        label: '创建人',
        prop: 'createUserName'
    },
    {
        label: '创建时间',
        prop: 'createTime',
        width: 130
    },
    {
        label: '修改人',
        prop: 'updateUserName'
    },
    {
        label: '修改时间',
        prop: 'updateTime',
        width: 130
    }
];

export const tableConfig = {
    selectBtn: true,
    lineBtn: true,
    leftOperation: true,
    leftWidth: '120px',
    action: [
        {
            label: '保存',
            type: 'text',
            event: 'save',
            displayRule: (row, type) => { return row.edit === type.EDIT; }
        }
    ],
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    }
};